import EcoBundle2 from 'eco-design/sections/eco-bundle-2';
import { useEffect, useMemo } from 'react';
import styles from './index.module.scss';
import { data1, data2 } from './data';
import useProductInfo from '@/utils/hooks/useProductInfo';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import { ENUM_ECO_CART_EVENT, ItfEcoCartItem } from 'eco-design/elements/eco-cart/type.d';

export default function JP_Bundles() {
    const { t } = useLang('theProduct.bundles');

    const getInfo = (i: any, idx: number, listName: string) => {
        const discount = Math.round((1 - i.price / (i.compareAtPrice || i.price)) * 100);
        const title = i.skuTitle === 'Default Title' ? i.productTitle : i.skuTitle;
        return {
            ...i,
            lChildren: Number(i?.inventoryQuantity || 0) <= 0 && i?.inventoryPolicy !== 'continue' ? t('btn3') : t('btn1'),
            lDisabled: Boolean(Number(i?.inventoryQuantity || 0) <= 0 && String(i?.inventoryPolicy) !== 'continue'),
            lRadius: 'ellipse',
            rChildren: Number(i?.inventoryQuantity || 0) && i?.inventoryPolicy !== 'continue' ? '' : t('btn2'),
            rRadius: 'ellipse',
            rType: 'outlined',
            pointsTextL: '倍',
            // pointsTimes: 5,

            title,
            desc: t(`p${idx}`),
            price: i.price,
            priceSuffix: '（税込）',
            comparePrice: i?.compareAtPrice > i.price ? i.compareAtPrice : null,
            rDisabled: Boolean(Number(i?.inventoryQuantity || 0) <= 0 && String(i?.inventoryPolicy) !== 'continue'),
            lBtnClick() {
                const { price, compareAtPrice, img, variantImg, inventoryPolicy, inventoryQuantity, productTitle, skuTitle, productId, variantId } = i;
                EcoDesignEventsBus.emit(ENUM_ECO_CART_EVENT.ECO_CART_ADD, [
                    {
                        price,
                        compareAtPrice,
                        img,
                        variantImg,
                        inventoryPolicy,
                        inventoryQuantity,
                        productTitle,
                        skuTitle,
                        productId: `${productId}`,
                        variantId: `${variantId}`,
                        quantity: 1,
                    } as ItfEcoCartItem,
                ]);
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'bundle_add_to_cart',
                    list_name: listName,
                    price: i.price,
                    product_name: title,
                    tag: 'none',
                    quantity: 1,
                    button_name: t('btn1'),
                });
            },
            rHref: `https://jp.ecoflow.com/cart/${i.variantId}:1?channel=buy_button`,
            rDataLayer: {
                event: 'uaEvent',
                event_name: 'checkout',
                button_name: `${t('btn2')}_${title}`,
            },
            discountTextL: i.price && discount > 0 ? `${discount}% OFF` : '',
        };
    };

    const list1 = useProductInfo(data1);
    const list2 = useProductInfo(data2);

    const bundleSections = useMemo(() => {
        const rawLists = [list1, list2];
        let index = 0;
        return rawLists.map((list, sectionIndex) => {
            const titleKey = `card${sectionIndex + 1}_title`;
            const title = t(titleKey);
            const items = list.map((item) => {
                index++;
                return {
                    imgs: [{ pc: item.variantImg || item.img }, { pc: item.pc, pad: item.pad, h5: item.h5 }],
                    info: getInfo(item, index, title),
                };
            });
            return { title, items };
        });
    }, [list1, list2]);

    return (
        <div className={styles.bundles}>
            {bundleSections.map(({ title, items }, index) => (
                <EcoBundle2 key={index} items={items?.filter((item: any) => typeof item.info?.price === 'number')} section={{ title }} />
            ))}
        </div>
    );
}
